import Iron from '../assets/images/Iron.svg';
import Driver from '../assets/images/Driver.svg';
import Fairway from '../assets/images/Fairway.svg';
import Putter from '../assets/images/Putter.svg';
import Wedge from '../assets/images/Wedge.svg';
import Mixed from '../assets/images/Mixed.svg';

const getClubImage = (product) => {
  const ClubImageMap = {
    IRONS: Iron,
    PUTTERS: Putter,
    DRIVERS: Driver,
    MIXED: Mixed,
    FAIRWAYS: Fairway,
    HYBRIDS: Fairway,
    WEDGES: Wedge,
  };

  if (ClubImageMap[product]) {
    return ClubImageMap[product];
  }
  return Iron;
};

export default getClubImage;
